import { Injectable } from '@angular/core';
import { Observable, forkJoin, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class PingService {
    private servers = ['https://be.adcaisse.online/bp-api-admin/v1/findAllByIdPointVente/55',
        'https://be1.adcaisse.online:8443/bp-api-admin/v1/findAllByIdPointVente/55',

    ];

    constructor(private http: HttpClient) { }

    private async urlExists(url: string, timeout: number = 1000): Promise<boolean> {
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), timeout);

        try {
            const response = await fetch(url, { mode: 'no-cors', signal: controller.signal });
            return true;
        } catch (error) {
            return false;
        } finally {
            if (!controller.signal.aborted) {
                clearTimeout(timeoutId);
            }
        }
    }

    findAvailableServer(): Observable<string> {
        const requests = this.servers.map((server) => this.urlExists(server));

        return forkJoin(requests).pipe(
            map((responses: boolean[]) => {
                const availableServerIndex = responses.findIndex((response) => response);
                return availableServerIndex !== -1 ? this.servers[availableServerIndex] : '';
            }),
            catchError(() => of('')) // Handle errors here, you can also throw an error if needed
        );
    }
}
